module.exports = __webpack_public_path__ + "nunito-sans-latin-900italic.0dc1055cf601fe66514482613ebdf168.woff2";